export interface Question {
    name?: string;
    code: string;
    text: string;
    title: string;
    subtitle?: string;
    selectedChoice?: number;
}

export type LifeMeaningChoice = {
    id: string;
    code: string;
    name: string;
    subtitle?: string;
    currentOrder: number;
  };



export interface SiteSettings {
    interest_test_name: string;
    interest_test_minute: number;
    interest_test_question: string;
    interest_test_description: string;
    personality_test_name: string;
    personality_test_minute: number;
    personality_test_question: string;
    personality_test_description: string;
    skill_test_name: string;
    skill_test_minute: number;
    skill_test_question: string;
    skill_test_description: string;
    life_meaning_test_name: string;
    life_meaning_test_minute: number;
    life_meaning_test_question: string;
    life_meaning_test_description: string;
    result_subtitle_text: string;
    outro_title: string;
    outro_body: string;
}



export function formatDateIgnoringTimeZone(date:Date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}


export function formatDateTime(isoString: string): string {
    const date = new Date(isoString);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getDate()).padStart(2, '0');
    // const hours = String(date.getHours()).padStart(2, '0');
    // const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}


export function numberToCommaString(number:number) {
    return number.toLocaleString();
}


export function formatNumberStringWithCommas(numberString: string): string {
    const number = parseFloat(numberString);
    if (isNaN(number)) {
        return numberString;
    }
    return number.toLocaleString('en-US');
}


export interface SchoolLite {
    pk: number;
    name: string;
}


export interface CareerLite {
    pk: number;
    name: string;
}


export interface Career {
    icon: string;
    name: string;
    code: string;
    fit_percentage: number;
    star_count: number;
    min_salary: number;
    avg_salary: number;
    max_salary: number;
    time_commitment: number;
    description: string;
    objective: string;
    imageSrc: string;
    courses: CareerCourse[];
    interest_percentages: CareerPercentageData[];
    personality_percentages: CareerPercentageData[];
    skill_percentages: CareerPercentageData[];
    life_meaning_percentages: CareerPercentageData[];
    money: number;
    time: number;
}


export interface ShortCareer {
    icon: string;
    name: string;
    code: string;
    fit_percentage: number;
    star_count: number;
    min_salary: number;
    avg_salary: number;
    max_salary: number;
    time_commitment: number;
    description: string;
    objective: string;
    imageSrc: string;
    courses: ShortCareerCourse[];
    interest_percentages: CareerPercentageData[];
    personality_percentages: CareerPercentageData[];
    skill_percentages: CareerPercentageData[];
    life_meaning_percentages: CareerPercentageData[];
    money: number;
    time: number;
}


interface ShortCareerCourse {
    name: string;
    schools: ShortCareerSchool[];
}

interface ShortCareerSchool {
    name: string;
}


interface CareerCourse {
    pk: number;
    name: string;
    study_year: number;
    schools: CareerSchool[];
    primary_subject_choices: CareerSubject[];
    secondary_subject_choices: CareerSubject[];
    primary_subject_point: number;
    secondary_subject_point: number;
}

interface CareerSchool {
    name: string;
    one_credit: string|null;
    total_credit: string|null;
    pk: number;
    display_image: string;
}

interface CareerSubject {
    pk: number;
    name: string;
}

interface CareerPercentageData {
    percentage: number;
    name: string;
    description: string;
    category: number;
}




export interface Article {
    publish_datetime: string;
    url: string;
    subtitle: string;
    title: string;
    author: string;
    read_minute: string;
    image_url: string;
    text: string|null;
};




export interface Video {
    publish_datetime: string;
    url: string;
    title_text_image_url: string;
    mobile_headshot_url: string;
    headshot_url: string;
    title: string;
    subtitle: string;
    description: string;
    youtube_embed: string;
};



export const salaryRanges = [
    { label: "1 сая ₮ доош", min: 0, max: 1000000 },
    { label: "1 - 2 сая ₮", min: 1000000, max: 2000000 },
    { label: "2 - 3 сая ₮", min: 2000000, max: 3000000 },
    { label: "3 - 4 сая ₮", min: 3000000, max: 4000000 },
    { label: "4 - 5 сая ₮", min: 4000000, max: 5000000 },
    { label: "5 - 10 сая ₮", min: 5000000, max: 10000000 },
    { label: "10 сая ₮ дээш", min: 10000000, max: Infinity },
];

export const timeCommitmentRanges = [
    { label: "1 жил", value: 1 },
    { label: "2 жил", value: 2 },
    { label: "3 жил", value: 3 },
    { label: "4 жил", value: 4 },
    { label: "5 жил", value: 5 },
    { label: "6 жил", value: 6 },
    { label: "6 жил дээш", value: Infinity },
];



export const starRange = [
    { value: 1, label: '★☆☆☆☆' },
    { value: 2, label: '★★☆☆☆' },
    { value: 3, label: '★★★☆☆' },
    { value: 4, label: '★★★★☆' },
    { value: 5, label: '★★★★★' },
]